// Strip a leading "Officer " prefix from a display name.
// "Officer Garcia"  -> "Garcia"
// "officer  Smith"  -> "Smith"
// "Admin"           -> "Admin"
// null / undefined  -> ""
export function displayName(name) {
  if (!name) return "";
  const trimmed = String(name).trim();
  if (trimmed.toLowerCase().startsWith("officer ")) {
    const rest = trimmed.slice("officer ".length).trim();
    return rest || trimmed;
  }
  return trimmed;
}

/** Minutes → "H:MM" (e.g. 95 → "1:35"). */
export const fmtHM = (m) => (m == null ? "—" : `${Math.floor(m / 60)}:${String(Math.round(m) % 60).padStart(2, "0")}`);
